/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-23 16:35:09
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-10-17 18:07:16
 * @FilePath: \hlweb2.0\src\pages\Home\ProductServices\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from "react";
import "./index.scss";
import { JumpApply } from "../../../components/Jump";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
function ProductServices() {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const productList = t("productList", { returnObjects: true });
  const history = useHistory();
  const language = localStorage.getItem("i18nextLng");

  const click = (url) => {
    console.log(url, "url");
    history.push(url);
  };
  return (
    <div className="home_productSerCon" id="home_productSerCon_id">
      <div className="edition_solution">
        <div className="edition_solution_title">
          {language === "zh" ? (
            <div>
              <a>{t("home.anchorPoint4Con.titleColor")}</a>{" "}
              {t("home.anchorPoint4Con.title")}
            </div>
          ) : (
            <div>
              {t("home.anchorPoint4Con.title1")}{" "}
              <a>{t("home.anchorPoint4Con.titleColor")}</a>{" "}
              {t("home.anchorPoint4Con.title2")}
            </div>
          )}

          <span>{t("home.anchorPoint4Con.detail")}</span>
        </div>
      </div>
      <div className="home_productSerCon_con">
        <ul className="home_productSerCon_con_tab">
          {productList.map((item, index) => {
            return (
              <li
                key={index}
                className={
                  index == activeIndex
                    ? "home_productSerCon_con_tab_active"
                    : " "
                }
                style={language === "zh" ? { height: "" } : { height: "65px" }}
                onMouseEnter={() => {
                  setActiveIndex(index);
                }}
              >
                <img
                  src={index == activeIndex ? item.imgIcon2 : item.imgIcon1}
                />
                {item.title}
              </li>
            );
          })}
        </ul>
        <div className="home_productSerCon_con_tab_con">
          <div className="tab_left">
            <div className="tab_left_con1">{productList[activeIndex].con1}</div>
            <div className="tab_left_con2">{productList[activeIndex].con2}</div>
            <div className="tab_left_con3">
              {productList[activeIndex].con3List.map((item, index) => {
                return <div>{item}</div>;
              })}
              {/* {productList[activeIndex].con3} */}
            </div>
            <div
              className="tab_left_btn"
              onClick={() => click(productList[activeIndex].jumpLine)}
            >
              {productList[activeIndex].jump}
            </div>
          </div>
          <div className="tab_right">
            <img src={productList[activeIndex].imgUrl} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductServices;
